export const getCommaList = (items: string[]): string => {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} and ${items[1]}`;

    const lastItem = items[items.length - 1];
    const firstItems = items.slice(0, items.length - 1);

    return `${firstItems.join(', ')}, and ${lastItem}`;
};
